// extracted by mini-css-extract-plugin
export var cardLayout = "_7h-1";
export var paginationContainer = "_7h-0";